<template>
  <section class="section container pt-0">
    <inventory-movement-datatable />
  </section>
</template>

<script>
import InventoryMovementDatatable from "./inventory_movement_datatable/Index.vue";

export default {
  name: "InventoryMovements",
  components: {
    InventoryMovementDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
